$(function() {
    $("section").on("inview", function(e, i, n, o) {
        i && $(this).stop().addClass("onview")
    })
}), $(function() {
    $('a[href^="#"]').click(function() {
        var e = 500,
            i = $(this).attr("href"),
            n = $("#" == i || "" == i ? "html" : i),
            o = n.offset().top;
        return $("html, body").animate({
            scrollTop: o
        }, 500, "swing"), !1
    })
}), $(window).on("load resize", function() {
    $("#ubu801 .hero_slider").bxSlider({
        auto: !0,
        mode: "fade",
        pause: 6e3,
        speed: 3e3,
        pager: !1,
        controls: !1,
        onSlideAfter: function(e, i, n) {
            $(".active").removeClass("active"), $("#ubu801 .hero_slider > div").eq(n + 1).addClass("active")
        },
        onSliderLoad: function() {
            $("#ubu801 .hero_slider > div").eq(1).addClass("active")
        }
    })
}), $(window).on("load resize", function() {
    var e = $("#ubu801 #interview .bx-viewport").height();
    console.log(e), $("#ubu801 .interview_slider").bxSlider({
        auto: !1,
        pager: !0,
        mode: "fade",
        infiniteLoop: "true",
        controls: !0,
        pagerType: "short"
    })
}), $(function() {
    $(window).on("load scroll resize", function() {
        var e = $(window).innerHeight(),
            i = $("#ubu801 #hero").innerHeight(),
            n = $("header").innerHeight(),
            o = $("#ubu801").innerHeight(),
            a = $(window).scrollTop();
        a > i + n && a + n > 0 && a < o && ($("#ubu801 .nav").addClass("fixed"), $("#ubu801 #lead .inner").addClass("reach"), $("#ubu801 #lead .sp").addClass("reach"), $(".nav").fadeIn()), a > o && $("#ubu801 .nav").fadeOut(), a < i + n && ($("#ubu801 .nav").removeClass("fixed"), $("#ubu801 #lead .inner").removeClass("reach"), $("#ubu801 #lead .sp").removeClass("reach"))
    })
});